<section id="datenschutzerklaerung">
  <h2>Datenschutzerklärung</h2>

  <h3>1. Verantwortlicher</h3>
  <address>
    <strong>Docuty GmbH</strong><br>
    Regensburger Straße 90<br>
    92318 Neumarkt i.d.OPf.<br>
    Deutschland<br>
    Telefon: <a href="tel:+4991812702200">+49 9181 2702200</a><br>
    E-Mail: <a href="mailto:info@docuty.de">info&#64;docuty.de</a>
  </address>
  <p>
    Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist die Docuty GmbH.
  </p>

  <h3>2. Allgemeine Hinweise zur Datenverarbeitung</h3>
  <p>
    Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Personenbezogene Daten werden vertraulich
    und gemäß den gesetzlichen Datenschutzvorschriften (insbesondere der DSGVO und des BDSG) sowie dieser
    Datenschutzerklärung behandelt.
  </p>
  <p>
    Die Nutzung unserer Website ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf
    unseren Seiten personenbezogene Daten (z. B. Name, Anschrift oder E-Mail-Adresse) erhoben werden,
    erfolgt dies stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht
    an Dritte weitergegeben.
  </p>
  <p>
    Wir weisen darauf hin, dass die Datenübertragung im Internet (z. B. bei der Kommunikation per E-Mail)
    Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist
    nicht möglich.
  </p>

  <h3>3. Erfassung von Daten auf unserer Website</h3>

  <h4>a) Server-Log-Dateien</h4>
  <p>
    Der Provider der Seiten erhebt und speichert automatisch Informationen in sogenannten Server-Log-Dateien,
    die Ihr Browser automatisch übermittelt. Dies sind:
  </p>
  <ul>
    <li>Browsertyp und Browserversion</li>
    <li>verwendetes Betriebssystem</li>
    <li>Referrer-URL</li>
    <li>Hostname des zugreifenden Rechners</li>
    <li>Uhrzeit der Serveranfrage</li>
    <li>IP-Adresse</li>
  </ul>
  <p>
    Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Die Erfassung dieser
    Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
  </p>

  <h4>b) Kontaktformular</h4>
  <p>
    Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben inklusive der dort
    angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns
    gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
  </p>
  <p>
    Die Verarbeitung der in das Kontaktformular eingegebenen Daten erfolgt somit ausschließlich auf
    Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Sie können diese Einwilligung jederzeit
    widerrufen.
  </p>

  <h4>c) Registrierung und Login für die Web-App</h4>
  <p>
    Wenn Sie sich auf unserer Website registrieren, werden die von Ihnen angegebenen Daten
    (z. B. Name, E-Mail-Adresse, Passwort) zur Einrichtung und Verwaltung des Benutzerkontos verarbeitet.
  </p>
  <p>
    Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung).
  </p>

  <h4>d) Cookies</h4>
  <p>
    Unsere Internetseiten verwenden Cookies. Cookies richten auf Ihrem Rechner keinen Schaden an und
    enthalten keine Viren. Sie dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer
    zu machen.
  </p>
  <p>
    Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und
    Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell
    ausschließen sowie das automatische Löschen der Cookies beim Schließen des Browsers aktivieren.
  </p>
  <p>
    Die Speicherung von Cookies erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
  </p>

  <h4>e) Analyse-Tools und Tracking</h4>
  <p>
    Diese Website kann Analyse-Dienste wie Google Analytics oder vergleichbare Tools einsetzen, um die
    Nutzung der Website statistisch auszuwerten.
  </p>
  <p>
    Die Erfassung und Auswertung erfolgt pseudonymisiert, die IP-Adresse wird anonymisiert gespeichert.
  </p>
  <p>
    Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung).
  </p>
  <p>
    Sie können Ihre Einwilligung zur Nutzung dieser Tools jederzeit über den Cookie-Banner oder die
    Einstellungen Ihres Browsers widerrufen.
  </p>

  <h4>f) Newsletter (optional)</h4>
  <p>
    Wenn Sie unseren Newsletter abonnieren, verwenden wir die hierfür erforderlichen Daten, um Ihnen
    regelmäßig Informationen zu unseren Angeboten zuzusenden.
  </p>
  <p>
    Die Anmeldung erfolgt per Double-Opt-In-Verfahren.
  </p>
  <p>
    Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO.
  </p>
  <p>
    Sie können sich jederzeit über den im Newsletter enthaltenen Link wieder abmelden.
  </p>

  <h4>g) Eingebettete Inhalte und externe Dienste</h4>
  <p>
    Diese Website kann externe Dienste wie Google Fonts, Google Maps, YouTube oder Social-Media-Plugins
    (z. B. LinkedIn, Facebook, Instagram) einbinden.
  </p>
  <p>
    Die Nutzung dieser Dienste erfolgt im Interesse einer ansprechenden Darstellung unseres
    Online-Angebots.
  </p>
  <p>
    Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO.
  </p>
  <p>
    Beim Aufruf der Seite werden möglicherweise Daten (z. B. IP-Adresse) an die jeweiligen Anbieter in
    die USA übermittelt.
  </p>

  <h3>4. Rechte der betroffenen Personen</h3>
  <p>
    Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf:
  </p>
  <ul>
    <li>Auskunft über Ihre gespeicherten personenbezogenen Daten (Art. 15 DSGVO)</li>
    <li>Berichtigung (Art. 16 DSGVO)</li>
    <li>Löschung (Art. 17 DSGVO)</li>
    <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
    <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
    <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
    <li>Widerruf erteilter Einwilligungen (Art. 7 Abs. 3 DSGVO)</li>
  </ul>
  <p>
    Zur Ausübung dieser Rechte wenden Sie sich bitte an:
    <a href="mailto:info@docuty.de">info&#64;docuty.de</a>
  </p>

  <h3>5. Aufbewahrungsdauer</h3>
  <p>
    Personenbezogene Daten werden nur so lange gespeichert, wie es zur Erreichung des jeweiligen Zwecks
    erforderlich ist oder gesetzliche Aufbewahrungsfristen bestehen.
  </p>

  <h3>6. Sicherheit</h3>
  <p>
    Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre durch uns verwalteten
    Daten gegen Manipulation, Verlust, Zerstörung oder unbefugten Zugriff zu schützen.
  </p>

  <h3>7. Änderung dieser Datenschutzerklärung</h3>
  <p>
    Wir behalten uns vor, diese Datenschutzerklärung bei Bedarf anzupassen, um sie stets den aktuellen
    rechtlichen Anforderungen oder Änderungen unserer Leistungen anzupassen.
  </p>
  <p>
    <em>Stand: Oktober 2025</em>
  </p>
</section>
